




import Vue from 'vue';
import MaterialDbDetail from '@/components/material-db/material-db-detail.component.vue';

export default Vue.extend({
  components: {
    'material-db-detail': MaterialDbDetail,
  },
});
